export default __webpack_public_path__ + "static/media/play-button.78e5e10d.png";